module.exports = __webpack_public_path__ + "static/media/logo.82eccea0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 96
// module chunks = 0